import React, { useMemo } from "react"
import Modal from "react-modal"
import { ModalBody, ModalBodyDownloadButton, ModalBodyTitle, ModalHeader, ModalHeaderCloseButton, ModalHeaderSubtitle, ModalHeaderTitle, ModalHeaderTitleWrapper, ModalRoot, ValueContainer, ValueGroup, ValueLabel } from "./DocumentationModal.styled"
import { DocumentSection } from "@/entities/Document"
import { Icon } from "../../shared/ui/Icon"
import { useGetFile } from "../../api/documentation/hooks/useGetFile"

interface DocumentationModalProps {
    isOpened: boolean
    selectedSection: DocumentSection,
    onClose: () => void
}

function mapStage(stage: string) {
    switch (stage) {
        case "П":
            return "Проектная документация";

        case "РД":
            return "Рабочая документация";

        default:
            return "Неизвестно";
    }
}

const customStyles = {
    content: {
        width: "70%",
        margin: "auto",
        padding: 0,
        height: "auto", // Разрешаем расти по высоте
        maxHeight: "none", // Убираем ограничение максимальной высоты
        overflow: "auto", // Убираем скролл (чтобы контент не обрезался)
        inset: "unset"
    },
    overlay: {
        backgroundColor: "rgba(0,0,0,0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"

    }
};

export const DocumentationModal: React.FC<DocumentationModalProps> = ({
    isOpened,
    onClose,
    selectedSection
}) => {
    const stage = useMemo(() => mapStage(selectedSection.stage), [selectedSection]);
    const { mutate } = useGetFile();

    const handleDownloadClick = () => {
        mutate({
            id: selectedSection.original.id,
            filename: selectedSection.original.name
        })
    }
    return (
        <Modal isOpen={isOpened} style={customStyles} shouldCloseOnOverlayClick={true} onRequestClose={() => onClose()}>
            <ModalRoot>
                <ModalHeader>
                    <ModalHeaderTitleWrapper>
                        <ModalHeaderTitle>{selectedSection.original.name}</ModalHeaderTitle>
                        <ModalHeaderSubtitle>({stage})</ModalHeaderSubtitle>
                    </ModalHeaderTitleWrapper>
                    <ModalHeaderCloseButton onClick={_ => onClose()}>
                        <Icon size={14} type="close" />
                    </ModalHeaderCloseButton>
                </ModalHeader>
                <ModalBody>
                    <ModalBodyTitle>
                        <Icon type="document" size={18} />
                        <span>Основная информация</span>
                        {selectedSection.original.fileId}
                    </ModalBodyTitle>
                    {!!selectedSection.original.fileId && <ModalBodyDownloadButton onClick={handleDownloadClick}>
                        <Icon size={14} type="download" />
                        Скачать файл
                    </ModalBodyDownloadButton>
                    }
                    <ValueGroup>
                        <ValueLabel>Наименование</ValueLabel>
                        <ValueContainer>{selectedSection.original.name} ({stage})</ValueContainer>
                    </ValueGroup>
                    <ValueGroup>
                        <ValueLabel>Статус</ValueLabel>
                        <ValueContainer>{selectedSection.original.documentStatus}</ValueContainer>
                    </ValueGroup>
                    <ValueGroup>
                        <ValueLabel>Версия</ValueLabel>
                        <ValueContainer>{selectedSection.original.version}</ValueContainer>
                    </ValueGroup>
                    <ValueGroup>
                        <ValueLabel>Дата изменения</ValueLabel>
                        <ValueContainer>{selectedSection.original.modified}</ValueContainer>
                    </ValueGroup>
                    <ValueGroup span={true}>
                        <ValueLabel>Проектировщик</ValueLabel>
                        <ValueContainer>{selectedSection.original.initiatorOrganization}</ValueContainer>
                    </ValueGroup>
                    <ValueGroup span={true}>
                        <ValueLabel>Примечание</ValueLabel>
                        <ValueContainer>{selectedSection.original.note}</ValueContainer>
                    </ValueGroup>
                </ModalBody>
            </ModalRoot>
        </Modal>
    )
}